import {
	Command,
	EditorState,
	Transaction
} from "prosemirror-state";

export const insertText = (text: string): Command => {
	return (
		state: EditorState,
		dispatch: ((tr: Transaction) => void) | undefined
	): boolean => {
		if (dispatch) {
			const transaction: Transaction = state.tr
				.insertText(text)
				.scrollIntoView();

			dispatch(transaction);
		}

		return true;
	};
};
